import { z } from 'zod'

export const commentFormSchema = z.object({
  content: z
    .string()
    .trim()
    .min(1, 'Comment cannot be empty')
    .max(500, '500 characters max'),
})

export type CommentFormInput = z.infer<typeof commentFormSchema>
